export default "__VITE_ASSET__L2HkpOYU__"